import { FC } from 'react';
import { CircularProgress } from '@mui/material';
import { Grid } from '@mui/system';
import useStyles from './styles';

const LoadingSection: FC = () => {
  const classes = useStyles();

  return (
    <Grid container justifyContent="center" alignItems="center" className={classes.loadingContainer}>
      <Grid size={{ xs: 12 }}>
        <CircularProgress />
      </Grid>
    </Grid>
  );
};

export default LoadingSection;
